import { render } from "./QuizNav.vue?vue&type=template&id=0fc463f4"
import script from "./QuizNav.vue?vue&type=script&lang=js"
export * from "./QuizNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__